import React from "react";
import { useCallback } from "react";
import { usePageContextFunction, usePageContextState } from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";
import analytics from "../../../utils/analytics";
import {
  CardContainer,
  CardContent,
  CardImage,
  CardTitle,
  Container,
  ImageWrapper,
} from "./CardCarousel.styled";

const CardCarousel = ({
  cardLomba = [],
  activeCarousel = 0,
  setActiveCarousel = () => {},
  contentType,
  dark = false,
}) => {
  const { size } = useWindowSize();
  const { city } = usePageContextState();

  const isMobileView = (size?.width || 0) <= 768;

  const decideCardLength = useCallback(() => {
    if (isMobileView) {
      // Dark (Jadwal/Klasemen) cards size to content so long labels like
      // "Perguruan Tinggi" fit on one line instead of cramming; the row scrolls.
      if (dark) return "auto";
      return cardLomba.length > 2 ? "150px" : "50%";
    }

    return `${Math.round(100 / cardLomba.length) - 1}%`;
  }, [isMobileView, cardLomba, dark]);

  return (
    <Container dark={dark}>
      {[...cardLomba].map((card, idx) => {
        const isActive = activeCarousel === card?.id;
        return (
          <CardContainer
            key={idx}
            onClick={() => {
              const eventType = contentType === "klasemen" ? "standingsPiala" : "matchTypePiala";
              const payload = {
                event: `${eventType}_${city ?? analytics.defaultCity}`,
                menu_name: card?.title,
              };
              analytics.sendEvent(payload);
              if (contentType === "klasemen") {
                analytics.sendEvent({ event: "klasemen_tab_pialabyu", title: card?.title });
              }
              setActiveCarousel(card?.id);
              // setActiveColor(`linear-gradient(
              //   to bottom,
              //   #fff 20%,
              //   ${card?.activeColor} 50%)`);
            }}
            width={decideCardLength()}
            isActive={isActive}
            activeBgColor={card?.activeBgColor}
            dark={dark}
          >
            <CardContent dark={dark}>
              <ImageWrapper
                isActive={isActive}
                iconActiveBgColor={card?.iconActiveBgColor}
                dark={dark}
              >
                <CardImage
                  $dark={dark}
                  src={card?.img}
                  alt={`Lomba ${card?.title}`}
                />
              </ImageWrapper>
              <CardTitle
                isActive={isActive}
                dark={dark}
                titleSize={card?.titleSize}
              >
                {card?.title}
              </CardTitle>
            </CardContent>
          </CardContainer>
        );
      })}
    </Container>
  );
};

export default CardCarousel;
